import {Component, OnInit} from '@angular/core';
import { GlobalServiceService } from '../global-service.service';
import {NgForm} from "@angular/forms";
import {HttpService} from "../http.service";
import {ContactFormSmallComponent} from "../homepage/contact-form-small.component";

@Component({
  selector: 'app-services-description',
  templateUrl: './services-description.component.html',
  styleUrls: ['./services-description.component.css']
})
export class ServicesDescriptionComponent implements OnInit {
  height: number;
  width: number;
  proportion: number = 0.656;
  constructor(private service: GlobalServiceService, private httpService: HttpService) { }

  ngOnInit(){
    this.onResize();
    ContactFormSmallComponent.hidePopup();
  }

  onResize(){
    this.height = this.service.getHeight(this.proportion);
  }

  onSubmit(form: NgForm) {
    let url = 'http://creativedigitalmailserver.us-west-2.elasticbeanstalk.com/mail?name=' + form.value.name.toString() + '&email='
      + form.value.email.toString() + '&phone=' + form.value.phone.toString() + '&budget=' + form.value.message.toString();
    this.httpService.sendOrder(url).subscribe(
      data => ContactFormSmallComponent.processSuccess(data.status.toString()),
      err => ContactFormSmallComponent.processFail(err)
    );
  }
}



// WEBPACK FOOTER //
// C:/Users/Artem/Desktop/Programming/studio/creativeDigital/src/app/services/services-description.component.ts